import {Directive, ElementRef, HostListener, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: '[bbNumberMask]'
})
export class NumberMaskDirective implements OnInit {
    stripChars = new RegExp('[^0-9]', 'g');

    constructor(
        public el: ElementRef,
        public renderer: Renderer2
    ) {
    }

    ngOnInit() {
        this.format(this.el.nativeElement.value); // format any initial values
    }

    @HostListener('input', ['$event.target.value']) onInput(e: string) {
        this.format(e);
    }

    @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
        event.preventDefault();
        this.format(event.clipboardData.getData('text/plain'));
    }

    format(val: string) {
        let numberFormat = String(val).replace(this.stripChars, '');
        if (numberFormat.length > 5) {
            numberFormat = numberFormat.substring(0, 4);
        }
        this.renderer.setProperty(this.el.nativeElement, 'value', numberFormat);
    }
}
